import { useEffect, useState } from 'react';
import { Email, renderFieldVerticalWrapper } from '@wkda/carlead-creation-components';
import { useTrackElementView } from '../../../hooks/useTrackElementView';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailWithTracking = () => {
  const [emailElement, setEmailElement] = useState(null);
  useEffect(() => {
    setEmailElement(document.getElementById('email'));
  }, []);
  useTrackElementView(emailElement, {
    category: 'lead-form',
    action: 'field-visible',
    leadFieldVisible: 'email',
    method: 'user'
  }, 'lead-form');
  return /*#__PURE__*/_jsx(Email, {
    isHiddenField: true,
    renderFieldWrapper: renderFieldVerticalWrapper
  });
};
export default EmailWithTracking;